/**
 * CihSection — layout wrapper for CIH page sections.
 *
 * Sections are separated by 1px rules, not background color swaps. The parent
 * page composes sections back-to-back and `divider` renders the rule above.
 *
 * Aliases: cih section, section wrapper, page section
 */

import type { ReactNode } from "react";

import { cn } from "~/lib/cn";

type CihSectionProps = {
  readonly children: ReactNode;
  readonly className?: string;
  /** Render a 1px top border to separate this section from the previous. Default true. */
  readonly divider?: boolean;
  readonly id?: string;
};

export function CihSection({
  children,
  className,
  divider = true,
  id,
}: CihSectionProps) {
  return (
    <section
      id={id}
      className={cn(
        "py-14 md:py-20",
        divider && "border-t border-gray-200",
        className,
      )}
    >
      {children}
    </section>
  );
}
